import * as React from 'react';
import { Button, CallOrder16 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { getIsFlatViewOrderEnabled } from '../../selectors/newbuilding';
import { useCallbackButton } from './useCallbackButton';

export function HeaderCallbackButton() {
  const [isAvailable, handleClick] = useCallbackButton('blockStickytop');
  const isFlatViewOrderEnabled = useSelector(getIsFlatViewOrderEnabled);

  if (!isAvailable) {
    return null;
  }

  return isFlatViewOrderEnabled ? (
    <Button theme="fill_secondary" size="XS" onClick={handleClick} beforeIcon={<CallOrder16 color={'primary_100'} />} />
  ) : (
    <Button theme="fill_secondary" size="XS" onClick={handleClick}>
      Перезвоните мне
    </Button>
  );
}
